export const organisationIndustries = [
  { label: "Consumer" },
  { label: "Financial Services" },
  { label: "Government" },
  { label: "Infrastructure, Logistics + Utilities" },
  { label: "Media + Technology" },
  { label: "Not-for-profit" },
  { label: "Professional Services" },
  { label: "Education" },
  { label: "Health & Fitness" },
  { label: "Property & Construction" },
  { label: "Leisure & Culture" },
];

export const organisationGovernmentPortfolios = [
  { label: "Agriculture, Fisheries and Forestry" },
  { label: "Attorney-General" },
  { label: "Climate Change, Energy, the Environment and Water" },
  { label: "Defence" },
  { label: "Education" },
  { label: "Employment and Workplace Relations" },
  { label: "Finance" },
  { label: "Foreign Affairs and Trade" },
  { label: "Health and Aged Care" },
  { label: "Home Affairs" },
  { label: "Industry, Science and Resources" },
  {
    label:
      "Infrastructure, Transport, Regional Development, Communications and the Arts",
  },
  { label: "Parliamentary Departments" },
  { label: "Prime Minister and Cabinet" },
  { label: "Social Services" },
  { label: "Treasury" },
  { label: "Veterans Affairs" },
];

export const organisationSecondaryIndustries = [
  { label: "Banking", value: "Banking" },
  { label: "Consultant", value: "Consultant" },
  { label: "Consumables", value: "Consumables" },
  { label: "Education", value: "Education" },
  { label: "Energy", value: "Energy" },
  { label: "Federal", value: "Federal" },
  { label: "Gaming", value: "Gaming" },
  { label: "Health", value: "Health" },
  { label: "Industry Body", value: "Industry Body" },
  { label: "Insurance", value: "Insurance" },
  { label: "Investing", value: "Investing" },
  { label: "Legal", value: "Legal" },
  { label: "Lending", value: "Lending" },
  { label: "Local", value: "Local" },
  { label: "Logistics", value: "Logistics" },
  { label: "Media", value: "Media" },
  { label: "NGO", value: "NGO" },
  { label: "Packaging", value: "Packaging" },
  { label: "Payments", value: "Payments" },
  { label: "Property", value: "Property" },
  { label: "Public Relations", value: "Public Relations" },
  { label: "Retail", value: "Retail" },
  { label: "Sport", value: "Sport" },
  { label: "State", value: "State" },
  { label: "Superannuation", value: "Superannuation" },
  { label: "Technology", value: "Technology" },
  { label: "Telecommunications", value: "Telecommunications" },
  { label: "Transport", value: "Transport" },
  { label: "Travel", value: "Travel" },
  { label: "Union", value: "Union" },
  { label: "Utilities", value: "Utilities" },
];
